import { Component, ChangeDetectionStrategy } from '@angular/core';

/** @see https://www.figma.com/file/yqBeq1MiGfpdN62SvmA8tg/RTLABS_GAS_DS_1?node-id=691%3A640 */
/** @description Separates content */
@Component({
  selector: 'gas-divider',
  templateUrl: './gas-divider.component.html',
  styleUrls: ['./gas-divider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasDividerComponent {
}
